import { render, staticRenderFns } from "./WxVideoPlayer.vue?vue&type=template&id=dd092d3c&scoped=true"
import script from "./WxVideoPlayer.vue?vue&type=script&lang=js"
export * from "./WxVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd092d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd092d3c')) {
      api.createRecord('dd092d3c', component.options)
    } else {
      api.reload('dd092d3c', component.options)
    }
    module.hot.accept("./WxVideoPlayer.vue?vue&type=template&id=dd092d3c&scoped=true", function () {
      api.rerender('dd092d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxVideoPlayer.vue"
export default component.exports